import { motion } from "framer-motion";
import { Search, ShieldCheck, Star, Phone, Smartphone, Globe } from "lucide-react";
import { useInView } from "@/hooks";
import { featureService } from "@/services/firebase";
import { useState, useEffect } from "react";
import type { Feature } from "@/types";

const iconMap: Record<string, React.ElementType> = {
  search: Search,
  "shield-check": ShieldCheck,
  star: Star,
  phone: Phone,
  smartphone: Smartphone,
  globe: Globe,
};

export function SolutionSection() {
  const { ref, isInView } = useInView();
  const [features, setFeatures] = useState<Feature[]>([]);

  useEffect(() => {
    featureService.getAll().then(setFeatures);
  }, []);

  return (
    <section id="solution" ref={ref} className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-4">
            Allo Artisan : la plateforme qui réconcilie clients et artisans.
          </h2>
          <p className="text-lg text-gray-500 max-w-3xl mx-auto">
            Une application mobile et un site web qui permettent aux particuliers et entreprises de Côte d'Ivoire de trouver, contacter et évaluer des artisans qualifiés en quelques minutes.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon] || Search;
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 40 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className={`bg-white rounded-2xl p-8 shadow-card hover:shadow-lg transition-all border border-gray-100 ${feature.highlight ? "ring-2 ring-primary/20" : ""}`}
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5"
                  style={{ backgroundColor: `${feature.color}15` }}
                >
                  <Icon className="w-7 h-7" style={{ color: feature.color }} />
                </div>
                <h3 className="text-xl font-bold text-dark mb-3">{feature.title}</h3>
                <p className="text-gray-500 leading-relaxed text-sm">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
